import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, Grid, Menu, MenuItem } from "@mui/material";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddIcon from "@mui/icons-material/Add";

import styles from "../home.module.css";
import { card_sx, grid_item_sx } from "./styled";
import { menu_item_for_link_sx, menu_item_sx } from "constant/styled";
import { ResponseDataType, getRequest } from "api";
import { toast } from "react-toastify";

// const circular_progress_sx = {
//   color: "#141D49",
// };
export interface OrganizationInfo {
  id: string;
  name: string;
  logo: string;
  numberOfMembers: number;
  memberAvatar: string;
  memberId: string;
  memberDepartmentCode: string;
}

// dữ liệu trả về từ API danh sách tổ chức.
interface OrgListDto {
  orgId?: string;
  orgList: OrganizationInfo[];
  memberId?: string;
}

export const Homeless = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [orgList, setOrgList] = useState<OrganizationInfo[] | undefined>();
  const customerId = localStorage.getItem("customerId");

  const getOrgList = async () => {
    const response: ResponseDataType<OrgListDto> = await getRequest(
      `/customer/get-org-list?${
        localStorage.getItem("customerId")
          ? `&customerId=${localStorage.getItem("customerId")}`
          : ""
      }${
        localStorage.getItem("organizationId")
          ? `&orgId=${localStorage.getItem("organizationId")}`
          : ""
      }`
    );
    const customerId = localStorage.getItem("customerId"); // Có thể là null
    console.log(customerId);

    if (response.code) {
      toast.error(response.message);
    }

    if (response.data?.orgId) {
      localStorage.setItem("organizationId", response.data.orgId);
    }
    setOrgList(response.data?.orgList);
  };

  const handleClick = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div className={styles.home_wrapper}>
      <Grid container spacing={5}>
        <Grid item sx={grid_item_sx}>
          <Link style={{ textDecoration: "none" }} to="/">
            <Card sx={card_sx}>
              <p className={styles.card_title}>Đề xuất</p>
              <p className={styles.card_number}>0</p>
              <Grid container justifyContent="flex-end">
                <RateReviewOutlinedIcon />
              </Grid>
            </Card>
          </Link>
        </Grid>
        <Grid item sx={grid_item_sx}>
          <Link style={{ textDecoration: "none" }} to="/">
            <Card sx={card_sx}>
              <p className={styles.card_title}>Công việc</p>
              <p className={styles.card_number}>0</p>
              <Grid container justifyContent="flex-end">
                <RateReviewOutlinedIcon />
              </Grid>
            </Card>
          </Link>
        </Grid>
      </Grid>
      <div
        id="create-option"
        style={{
          borderRadius: "50%",
          position: "fixed",
          left: "20px",
          bottom: "20px",
        }}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <AddCircleIcon
          sx={{
            fontSize: "70px",
            cursor: "pointer",
            color: "black",

            "@media (max-width: 480px)": {
              fontSize: "50px",
            },
          }}
        />
      </div>
      <Menu
        // anchorPosition={}
        id="create-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        autoFocus={false}
        MenuListProps={{
          "aria-labelledby": "create-option",
        }}
        PaperProps={{
          sx: {
            borderRadius: "10px",
            padding: "5px",
            marginTop: "-90px",
            border: "solid 1px #cacaca",
            boxShadow: "none",
          },
        }}
      >
        <MenuItem sx={menu_item_for_link_sx}>
          <Link className={styles.link_in_option_menu} to="/">
            <AddIcon />
            &nbsp;Tạo việc
          </Link>
        </MenuItem>
        <div className={styles.line} />
        <MenuItem sx={menu_item_sx}>
          <AddIcon />
          &nbsp;Tạo đề xuất
        </MenuItem>
      </Menu>
    </div>
  );
};
